import CourseScreen from "./CourseScreen";


export default CourseScreen;